import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import store from "../../store";
import { Header, MainColorButton, Loading } from "../../components";
import { bottomButton } from "../../common/styles";
import {
  CUSTOMER_PRE_INFO,
  MEDICAL_QUESTIONNAIRES,
  FAMILY_ADDER,
} from "../../routes/path";
import getLineProfile from "../../utils/getLineProfile";
import { getCustomerInfo } from "../../server/axios";

/**
 * 利用者選択画面
 * @returns
 */
const CustomerSelector = () => {
  const [endY, setEndY] = useState(0);
  // to avoid render twice locally from react strict mode
  const firstRenderRef = useRef(true);
  const navigate = useNavigate();
  //選択された利用者情報を保存
  const [selectedUser, setSelectedUser] = useState();
  //本人の情報をDEFAULTで
  const [rows, setRows] = useState([]);
  //Loadingコンポネント表示非表示state
  const [loadingOpen, setLoadingOpen] = useState(false);
  //初期データ
  const [resData, setResData] = useState();

  const getData = (lineId) => {
    setLoadingOpen(true);
    getCustomerInfo({ lineId }).then((res) => {
      setResData(res.data);
      if (res.data.isNew) {
        navigate(CUSTOMER_PRE_INFO);
      } else {
        let families = [
          {
            id: 1,
            name: "本人",
            relation: "－",
            flag: res.data.interviewFlg === true ? "済" : "未",
            customerId: res.data.customerId,
            siteId: res.data.siteId,
            familyId: 0,
            fullName: `${res.data.lastName}${res.data.firstName}`,
            gender: res.data.gender,
            birthday: res.data.birthday,
          },
        ];
        if (res.data.families) {
          families = families.concat(
            res.data.families.map((f, i) => ({
              id: i + 2,
              name: `${f.lastName}${f.firstName}`,
              relation: f.relationshipClassText,
              flag: f.interviewFlg === true ? "済" : "未",
              customerId: f.customerId,
              siteId: f.siteId,
              familyId: f.familyId,
              gender: f.gender,
              birthday: f.birthday,
            }))
          );
        }
        setRows(families);
      }
      setLoadingOpen(false);
    });
  };

  useEffect(() => {
    // to avoid render twice locally from react strict mode
    if (process.env.NODE_ENV === "development" && firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    const selectLineInfo = (state) => state.prescription.lineInfo;
    const lineInfo = selectLineInfo(store.getState());
    if (lineInfo.lineId) {
      getData(lineInfo.lineId);
    } else {
      getLineProfile().then((profile) => {
        getData(profile.userId);
      });
    }
  }, []);

  const addNewFamily = () => {
    const samePersonCheckArray = resData.families.map((f) => ({
      lastName: f.lastName,
      firstName: f.firstName,
      birthday: f.birthday,
    }));
    samePersonCheckArray.push({
      lastName: resData.lastName,
      firstName: resData.firstName,
      birthday: resData.birthday,
    });
    navigate(FAMILY_ADDER, {
      state: {
        customerId: resData?.customerId,
        siteId: resData?.siteId,
        samePersonCheckArray,
      },
    });
  };

  return (
    <div
      onTouchStartCapture={(e) => {
        setEndY(0);
      }}
      onTouchMoveCapture={(e) => {
        setEndY(e.touches[0].clientY);
      }}
      onTouchEndCapture={(e) => {
        if (endY !== 0) {
          e.stopPropagation();
        }
      }}
    >
      <Loading open={loadingOpen} />
      <Header title="問診" />
      <Box
        sx={{ height: "76vh", overflowY: "scroll" }}
        marginTop="9vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
      >
        <Stack>
          <Typography variant="inherit" align="left" marginBottom="1vh">
            問診を行う利用者を選択してください。
          </Typography>
          <MainColorButton
            label="家族追加"
            style={{ height: "4vh", marginBottom: "1vh" }}
            onClick={addNewFamily}
          />
          <TableContainer
            component={Paper}
            elevation={0}
            variant="outlined"
            sx={{ width: "auto" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    align="left"
                    padding="none"
                    sx={{
                      backgroundColor: "#E2EFDA",
                      padding: "2%",
                    }}
                  >
                    <strong>No</strong>
                  </TableCell>
                  <TableCell
                    align="left"
                    padding="none"
                    sx={{
                      backgroundColor: "#E2EFDA",
                      padding: "2%",
                    }}
                  >
                    <strong>名前</strong>
                  </TableCell>
                  <TableCell
                    align="center"
                    padding="none"
                    sx={{
                      backgroundColor: "#E2EFDA",
                      padding: "2%",
                    }}
                  >
                    <strong>続柄</strong>
                  </TableCell>
                  <TableCell
                    align="center"
                    padding="none"
                    sx={{
                      backgroundColor: "#E2EFDA",
                      padding: "2%",
                    }}
                  >
                    <strong>問診</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell
                      align="left"
                      sx={{
                        backgroundColor:
                          selectedUser && selectedUser.index === index
                            ? "rgba(226, 239, 218, 0.6)"
                            : undefined,
                      }}
                      onTouchEnd={() => setSelectedUser({ ...row, index })}
                    >
                      {row.id}
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        backgroundColor:
                          selectedUser && selectedUser.index === index
                            ? "rgba(226, 239, 218, 0.6)"
                            : undefined,
                      }}
                      onTouchEnd={() => setSelectedUser({ ...row, index })}
                    >
                      {row.name}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor:
                          selectedUser && selectedUser.index === index
                            ? "rgba(226, 239, 218, 0.6)"
                            : undefined,
                      }}
                      onTouchEnd={() => setSelectedUser({ ...row, index })}
                    >
                      {row.relation}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor:
                          selectedUser && selectedUser.index === index
                            ? "rgba(226, 239, 218, 0.6)"
                            : undefined,
                      }}
                      onTouchEnd={() => setSelectedUser({ ...row, index })}
                    >
                      {row.flag}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Box>
      <MainColorButton
        label="次へ"
        onClick={() =>
          navigate(MEDICAL_QUESTIONNAIRES, { state: selectedUser })
        }
        style={bottomButton}
        disabled={!selectedUser}
      />
    </div>
  );
};

export default CustomerSelector;
